import { generateResourceSelectors } from '../generators/resource.selectors';

import * as types from './conclusion.types';

export const conclusionSelectors = {
  ...generateResourceSelectors<types.IConclusion>((state) => state.resource.conclusion),
};
